import { createContext } from 'react';

export const CalcContext = createContext([true, {} as any]); //計算ボタンが押せる
export const BtnContext = createContext([true, {} as any]); //確定ボタンが押せる
export const CalenderContext = createContext([true, {} as any]); //カレンダーを選択する
export const UsableTriggerContext = createContext([true, {} as any]); //初期設定料金に紐づくフィールドが有効/無効になるイベント発火用
